/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ShiftBid = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        scheduleId: {
    type: 'number',
    isRequired: true,
},
        bidder: {
    type: 'number',
    isRequired: true,
},
        status: {
    type: 'ShiftBidStatus',
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        archivedAt: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
    },
};